import { MouseEventHandler } from 'react';
import { ButtonBaseProps, sizeClass, styleClasses } from '@/Components/ButtonBase';

interface ButtonProps extends ButtonBaseProps {
    onClick?: MouseEventHandler<HTMLButtonElement>,
    type?: 'button' | 'submit',
    form?: string,
}

export default function Button({
                                   form,
                                   style = 'primary',
                                   size = 'sm',
                                   onClick,
                                   type = 'button',
                                   disabled = false,
                                   children,
                                   className,
                               }: ButtonProps) {
    return (
        <button
            form={form}
            onClick={(e) => {
                onClick ? onClick(e) : undefined;
            }}
            disabled={disabled ?? false}
            type={type ?? 'button'}
            className={`text-sm rounded border flex items-center transition ease-in-out duration-200 disabled:opacity-75 disabled:cursor-not-allowed font-normal ${sizeClass[size]} ${styleClasses[style]} ${className ?? ''}`}>
            {children}
        </button>
    );
}
